// extracted by css-extract-rspack-plugin
export default {"mediaColumnWrapper":"_d5efaebf","mainMedia":"_8b24ca11","mainVideo":"_92b43904"};